var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12501 0.950009C7.31251 0.950009 7.46251 1.02501 7.61251 1.17501L17.025 11.225C17.6625 11.9375 17.6625 13.0625 17.025 13.7375L7.6125 23.825C7.35 24.0875 6.9375 24.0875 6.675 23.8625C6.4125 23.6 6.4125 23.1875 6.6375 22.925L16.0875 12.875C16.275 12.6875 16.275 12.35 16.0875 12.125L6.63751 2.07501C6.37501 1.81251 6.41251 1.40001 6.67501 1.13751C6.78751 1.02501 6.97501 0.950009 7.12501 0.950009Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24.5) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft1);
export default __webpack_public_path__ + "static/media/chevron-left 1.09dd860423a7754b1220a7ee9be47689.svg";
export { ForwardRef as ReactComponent };